import { render, staticRenderFns } from "./TenantInvoiceAttachmentsModal.vue?vue&type=template&id=5406b922&scoped=true&"
import script from "./TenantInvoiceAttachmentsModal.vue?vue&type=script&lang=js&"
export * from "./TenantInvoiceAttachmentsModal.vue?vue&type=script&lang=js&"
import style0 from "./TenantInvoiceAttachmentsModal.vue?vue&type=style&index=0&id=5406b922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406b922",
  null
  
)

export default component.exports